import { addRecoilKey } from '@infield/utils/recoil';
import { atom } from 'recoil';

export const selectedActivityAtom = atom({
  key: addRecoilKey('activity-list-selected-activity'),
  default: '',
});
